import React, { useMemo, useState, useEffect, useCallback } from "react";
import TableContainer from "../../../Components/Common/TableContainerReactTable";
import { getProductReviews, deleteProductReview } from "../../../api/ecommerce";
import { toast } from "react-toastify";

const StarRating = ({ rating }) => {
  const r = Math.min(5, Math.max(0, Number(rating) || 0));
  return (
    <div className="text-warning">
      {[...Array(5)].map((_, i) => (
        <i key={i} className={`ri-star-${i < r ? "fill" : "line"}`}></i>
      ))}
    </div>
  );
};

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
const IMG_BASE = (API_BASE || "").replace("/api", "") || "http://localhost:5001";

const ReViewTable = () => {
  const [searchTable, setSearchTable] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProductReviews()
      .then((res) => {
        const data = res?.data || res || [];
        setSearchTable(Array.isArray(data) ? data.map((r) => ({
          id: r.id,
          product: r.product_name || r.product || "N/A",
          user: r.user_name || r.user || "Anonymous",
          rating: r.rating || 0,
          comment: r.comment || "",
          location: r.location || "",
          image: r.image ? `${IMG_BASE}/images/products/${r.image}` : "https://via.placeholder.com/60",
          createdat: r.created_at ? new Date(r.created_at).toISOString().split("T")[0] : "",
        })) : []);
      })
      .catch(() => setSearchTable([]))
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = useCallback((id) => {
    if (!window.confirm("Delete this review?")) return;
    deleteProductReview(id)
      .then(() => {
        toast.success("Review deleted");
        setSearchTable((prev) => prev.filter((r) => r.id !== id));
      })
      .catch(() => toast.error("Failed to delete review"));
  }, []);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "id",
      enableColumnFilter: false,
      cell: (cell) => (
        <span className="fw-semibold">{cell.getValue()}</span>
      ),
    },
    {
      header: "Product",
      accessorKey: "product",
      enableColumnFilter: false,
    },
    {
      header: "User",
      accessorKey: "user",
      enableColumnFilter: false,
    },
    {
      header: "Rating",
      accessorKey: "rating",
      enableColumnFilter: false,
      cell: (cell) => <StarRating rating={cell.getValue()} />,
    },
    {
      header: "Comment",
      accessorKey: "comment",
      enableColumnFilter: false,
    },
    {
      header: "Location",
      accessorKey: "location",
      enableColumnFilter: false,
    },
    {
      header: "Image",
      accessorKey: "image",
      enableColumnFilter: false,
      cell: (cell) => (
        <img
          src={cell.getValue()}
          alt="review"
          width="50"
          height="50"
          className="rounded"
        />
      ),
    },
    {
      header: "Created At",
      accessorKey: "createdat",
      enableColumnFilter: false,
    },

    // ⭐ ACTION COLUMN
    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      cell: (cell) => (
        <div className="d-flex gap-2">
          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(cell.row.original.id)}>
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    }

  ], [handleDelete]);

  return (
    <TableContainer
      columns={columns}
      data={searchTable}
      isGlobalFilter={true}
      customPageSize={5}
      SearchPlaceholder="Search..."
    />
  );
};

export default ReViewTable;